<template>
  <div>
    <header>
      <top-bar/>
    </header>
    <div class="container">
      <slot/>
    </div>
    <div class="headband">
      <div class="container">
        <div class="row">
          <div class="col s6 left-align">
            <img src="/static/img/headband-a.png" alt class="responsive-img">
          </div>
          <div class="col s6 right-align">
            <img src="/static/img/headband-b.png" alt class="responsive-img">
          </div>
        </div>
      </div>
    </div>
    <footer class="page-footer grey darken-2">
      <div class="container">
        <div class="row">
          <div class="col l4 s12">
            <h5 class="white-text">Sistema RRHH</h5>
            <p class="grey-text text-lighten-4">Sistema diseñado para facilitar y agilizar tramites del departamento de <strong>Recursos Humano</strong>.</p>
          </div>
          <div class="col l4 s12">
            <h5 class="white-text">Acciones</h5>
            <ul>
              <li><a class="grey-text text-lighten-3" href="#!"><i class="fas fa-user-circle"></i> Editar Perfil</a></li>
              <li><a class="grey-text text-lighten-3" href="#!"><i class="fas fa-key"></i> Cambiar Contraseña</a></li>
              <li><a class="grey-text text-lighten-3" href="#!"><i class="fas fa-comments"></i> Enviar un mensaje</a></li>
              <li><a class="grey-text text-lighten-3" href="#!" @click.prevent="logout"><i class="fas fa-sign-out-alt"></i> Salir del Sistema</a></li>
            </ul>
          </div>
          <div class="col l4 s12">
            <h5 class="white-text">Enlaces de Interes</h5>
            <ul>
              <li><a class="grey-text text-lighten-3" target="_blank" href="#!"><i class="fas fa-check"></i> Gobierno de Yaracuy</a></li>
              <li><a class="grey-text text-lighten-3" target="_blank" href="http://www.inces.gob.ve/wp-content/uploads/2017/10/lot.pdf"><i class="fas fa-check"></i> LOTTT</a></li>
              <li><a class="grey-text text-lighten-3" target="_blank" href="#!"><i class="fas fa-check"></i> Contraloría</a></li>
              <li><a class="grey-text text-lighten-3" target="_blank" href="#!"><i class="fas fa-check"></i> Seguro Social</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-copyright grey darken-3">
        <div class="container">
          Gobernación del estado Bolivariano de Yaracuy
          |
          Desarrollado por
          <a class="orange-text text-lighten-3" href="http://materializecss.com">Alfonzo Diez</a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import TopBar from '@/components/TopBar.vue'

export default {
  methods: {
    logout () {
      this.$store.commit('logout')
      this.$router.push('/login')
    }
  },
  components: {
    Breadcrumb,
    TopBar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/Dashboard.vue